import { render, staticRenderFns } from "./StatArea.vue?vue&type=template&id=2bef76f5&scoped=true&"
import script from "./StatArea.vue?vue&type=script&lang=js&"
export * from "./StatArea.vue?vue&type=script&lang=js&"
import style0 from "./StatArea.vue?vue&type=style&index=0&id=2bef76f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef76f5",
  null
  
)

export default component.exports